import { useMutation } from '@tanstack/react-query';
import { useOrganizationStore } from '../../stores/useOrganizationStore';
import {
  updateContactConsent,
  type ContactConsentUpdate,
  type ContactConsentUpdateResponse,
} from '../../api/consent';

interface UpdateConsentVariables {
  contactId: string;
  update: ContactConsentUpdate;
}

/**
 * Set global and/or per-channel consent. Each channel is tri-state: omit it to
 * leave it untouched. Both consent reads are Apollo-backed, so callers refetch
 * those themselves rather than invalidating a React Query key here.
 */
export const useUpdateContactConsent = () => {
  const { organization } = useOrganizationStore();
  const organizationId = organization?.id;

  return useMutation<ContactConsentUpdateResponse, Error, UpdateConsentVariables>({
    mutationFn: ({ contactId, update }) => {
      if (!organizationId) {
        throw new Error('No organization selected');
      }
      return updateContactConsent(contactId, organizationId, update);
    },
  });
};
